/** Shield frame — Figma 11059:2018 */
export default function RapCardShieldBorder() {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 400 749"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      style={{ display: 'block' }}
    >
      <path
        d="M340.412 76.3291C340.412 87.3573 344.794 97.9343 352.592 105.732C360.389 113.529 370.964 117.909 381.99 117.91C384.385 117.906 386.775 117.697 389.134 117.282L395 116.251V630.541L389.18 629.573C387.478 629.29 385.756 629.147 384.031 629.145C378.958 629.147 373.961 630.387 369.476 632.758C364.989 635.129 361.15 638.561 358.29 642.753C355.431 646.945 353.638 651.773 353.067 656.815C352.497 661.858 353.167 666.963 355.018 671.688L356.76 676.138L352.395 678.08L210.396 741.261L210.382 741.267L210.369 741.272C207.099 742.704 203.567 743.444 199.997 743.444C196.427 743.444 192.896 742.704 189.626 741.272L189.613 741.268L189.601 741.262L47.5 678.081L43.1279 676.137L44.8779 671.684C46.7347 666.959 47.4088 661.851 46.8418 656.807C46.2748 651.762 44.4841 646.932 41.625 642.737C38.7658 638.543 34.9248 635.11 30.4365 632.738C25.9489 630.367 20.9498 629.127 15.874 629.128C14.1765 629.13 12.4818 629.269 10.8066 629.543L5 630.492V116.105L10.9141 117.206C13.4405 117.676 16.0054 117.912 18.5752 117.911H18.5781C24.0397 117.912 29.448 116.837 34.4941 114.748C39.5405 112.659 44.126 109.595 47.9883 105.733C51.8505 101.872 54.9149 97.2873 57.0049 92.2412C59.0949 87.195 60.1696 81.786 60.1689 76.3242V76.3203C60.1771 65.9109 56.267 55.8792 49.2158 48.2217L44.9785 43.6201L50.4014 40.501C88.7667 18.4321 140.602 5 197.471 5C256.248 5.00008 309.65 19.3482 348.364 42.7549L353.276 45.7256L349.66 50.1836C343.665 57.5746 340.399 66.8056 340.412 76.3223V76.3291Z"
        fill="url(#rapcard-shield-gradient)"
        stroke="#FFD700"
        strokeWidth="10"
      />
      <defs>
        <linearGradient
          id="rapcard-shield-gradient"
          x1="200"
          y1="10"
          x2="200"
          y2="685.444"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#660061" />
          <stop offset="0.52228" stopColor="#6822CC" />
          <stop offset="1" stopColor="#FF00F2" />
        </linearGradient>
      </defs>
    </svg>
  );
}
